module.exports = __webpack_public_path__ + "img/rebeca-lan.04504adb.jpg";